module.exports = __webpack_public_path__ + "img/bg-induce-04.d51b36be.png";